// Design tokens for the new Super Admin surface, transcribed from the approved Figma
// ("New Super Admin"). One source of truth so every screen is pixel-consistent. Values are
// literal so they can be read straight into styled-components without a theme provider.

export const sa = {
  color: {
    // Brand / action
    teal: '#007a7a', // primary action, progress fill, active tab, leaderboard emphasis
    tealDark: '#006666',
    purple: '#45338c', // table header background
    pink: '#e84f6b', // GROUP badge text, over-allowance usage, destructive
    blue: '#53b5e0', // SCHOOL badge text

    // Surfaces
    white: '#ffffff',
    page: '#f2fbfd', // app canvas tint behind cards
    rowAlt: '#f5f5f5', // zebra table row
    mist: '#e8e6e6', // progress track, toggle background
    tabInactive: '#f3f4f6',

    // Badge fills
    groupBg: '#fadae0',
    schoolBg: '#dbf5ff',

    // Text
    text: '#111111',
    textGray: '#6d6d6d',
    kpiLabel: '#6b7280',
    kpiValue: '#111827',

    // Strokes
    stroke: '#e2e2e2',
    strokeLight: '#e5e7eb',

    // KPI accent underlines (left→right on the metrics bar)
    accentBlue: '#3b82f6',
    accentOrange: '#f97316',
    accentAmber: '#f59e0b',
    accentGreen: '#10b981',
  },

  radius: {
    sm: '4px', // buttons, badges, inputs, tab pills
    md: '8px', // table containers
    lg: '12px', // KPI bar, large cards
    chip: '16px', // toggle active segment
    pill: '20px', // toggle track
    avatar: '22px',
  },

  space: {
    page: '40px', // content-area padding
    section: '20px', // gap between stacked sections
    card: '24px',
    cell: '16px', // table cell padding
  },

  font: {
    family: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    // weights used across the design
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },

  shadow: {
    header: '0px 5px 3px rgba(0,0,0,0.03)',
    card: '0 1px 2px rgba(0,0,0,0.04)',
  },
};

// Type badge → { bg, fg } from the design.
export const badgeStyle = (type) =>
  String(type).toUpperCase() === 'GROUP'
    ? { bg: sa.color.groupBg, fg: sa.color.pink }
    : { bg: sa.color.schoolBg, fg: sa.color.blue };

// Progress fill: teal until it runs hot near/over allowance, then pink (matches the design,
// where 92% renders pink and lower values render teal).
export const usageFill = (pct) => (Number(pct) >= 90 ? sa.color.pink : sa.color.teal);
